module.exports = __webpack_public_path__ + "img/new_2.405384f0.png";